define.alias("@ember/render-modifiers/modifiers/did-insert", "settings/modifiers/did-insert");